export default "__VITE_ASSET__e58fd4e2__"